/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_VersionInputs */

const en_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Version`)
};

const es_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión actual`)
};

const fr_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version actuelle`)
};

const de_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Version`)
};

const ja_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のバージョン`)
};

const zh_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前版本`)
};

const ar_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإصدار الحالي`)
};

const id_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versi Saat Ini`)
};

const it_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versione Attuale`)
};

const ru_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущая версия`)
};

const pt_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão Atual`)
};

const ko_field_version = /** @type {(inputs: Field_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 버전`)
};

/**
* | output |
* | --- |
* | "Current Version" |
*
* @param {Field_VersionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_version = /** @type {((inputs?: Field_VersionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_VersionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_version(inputs)
	if (locale === "es") return es_field_version(inputs)
	if (locale === "fr") return fr_field_version(inputs)
	if (locale === "de") return de_field_version(inputs)
	if (locale === "ja") return ja_field_version(inputs)
	if (locale === "zh") return zh_field_version(inputs)
	if (locale === "ar") return ar_field_version(inputs)
	if (locale === "id") return id_field_version(inputs)
	if (locale === "it") return it_field_version(inputs)
	if (locale === "ru") return ru_field_version(inputs)
	if (locale === "pt") return pt_field_version(inputs)
	return ko_field_version(inputs)
});